// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import React from "react"
import Notification from "../Notification"
import { useContentJsx } from "@/utils/hooks/useContent"
import {
  sciStartDate,
  useExtendedInsuranceData,
} from "@/utils/hooks/useInsurance"

function SalaryContinuanceIncrease() {
  const { isFetching, sciInsurance, sciChangeAllowed } =
    useExtendedInsuranceData()

  const startDatePlusWaiting =
    sciInsurance && sciStartDate(sciInsurance?.sciEffectDate)

  const { contentBody: content } = useContentJsx({
    path: `dashboard_notifications.sci_increase`,
    date: startDatePlusWaiting,
  })

  if (isFetching || !sciInsurance) {
    return null
  }

  if (sciChangeAllowed) {
    return (
      <Notification notificationType={"alert"} closeButton={true}>
        {content}
      </Notification>
    )
  }

  return null
}

export default SalaryContinuanceIncrease
